export const homeContent = {
    resume: process.env.REACT_APP_RESUME_URL?.trim() || '/static/resume/Resume.pdf',
    experience: [
        {
            start_date: '2025-05',
            end_date: null,
            logo: 'seagate-logo.png',
            title: 'Software Engineer Intern',
            company: 'Seagate Technology',
            location: 'Fremont, California, United States',
            description:
                "Contributing to Seagate's Lyve Cloud team on large-scale, cloud-native storage and data engineering solutions. Optimized Go + gRPC migration workflows (35% throughput gain), built Kubernetes/Docker microservices (40% faster deployments), and enhanced Kafka + Spark pipelines (50M+ events/day, 30% lower latency). Improved observability with Grafana + CloudWatch, reducing downtime by 20%.",
            skills: [
                'Python',
                'Go',
                'Cassandra',
                'Redis',
                'PostgreSQL',
                'AWS',
                'Docker',
                'Kubernetes',
            ],
        },
        {
            start_date: '2022-08',
            end_date: '2024-07',
            logo: 'hansen-logo.png',
            title: 'Associate Software Engineer',
            company: 'Hansen Technologies',
            location: 'Pune, Maharashtra, India',
            description:
                'Developed high-throughput data pipelines with Apache Kafka (120 -> 800 req/s) and optimized Elasticsearch sharding for large-scale analytics. Enhanced microservices performance (30% faster processing) and led system monitoring via Grafana + AWS CloudWatch. Drove performance testing with JMeter and delivered scalable, reliable solutions for mission-critical data processing.',
            skills: [
                'Python',
                'Java',
                'Elasticsearch',
                'MongoDB',
                'Apache Kafka',
                'AWS',
                'Docker',
                'Kubernetes',
            ],
        },
    ],
};
